export enum Color {
    RED,
    GREEN,
    BLUE,
}
